import { DecimalRange } from '@bpd-library/utilities';

const generateSteps = ({
    range,
    stepSize,
    transformFn,
}: {
    range: DecimalRange;
    stepSize: number;
    transformFn?: (number: number) => number;
}) => {
    let from = range.from;
    let to = range.to;
    const steps: number[] = [];

    if (!from && !to) {
        return [];
    } else {
        if (!from) {
            return [to!];
        } else if (!to) {
            return [from!];
        }
    }

    if (transformFn) {
        from = transformFn(from);
        to = transformFn(to);
    }

    for (let step = from; step < to + stepSize; step += stepSize) {
        if (step > to) {
            steps.push(to);
        } else {
            steps.push(step);
        }
    }

    return steps;
};

export { generateSteps };
